import { createBrowserHistory } from 'history';
import { checkForMobileCookies } from '../../utils/src/axios/request-headers';

const getHistory = () => {
  const { pathname } = window.location;

  return createBrowserHistory({
    basename:
      pathname.includes('procurement') || checkForMobileCookies()
        ? '/procurement'
        : '/purchase'
  });
};

const history = getHistory();

export default history;
